(function(){
  var rm=matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.pu').forEach(function(el){
    var segs=[];
    if(el.dataset.puMulti){ try{segs=JSON.parse(el.dataset.puMulti);}catch(e){} }
    if(!segs.length) segs=[{t:el.dataset.pu||el.textContent,c:''}];
    el.textContent='';
    var n=0;
    segs.forEach(function(s,si){
      String(s.t).split(' ').forEach(function(w){
        var i=document.createElement('i');
        if(s.c) i.className=s.c;
        i.textContent=w+' ';
        i.style.transitionDelay=(n*0.08)+'s';
        el.appendChild(i); n++;
      });
      if(si<segs.length-1) el.appendChild(document.createTextNode(' '));
    });
  });

  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);} });
  },{rootMargin:'0px 0px -10% 0px',threshold:.15});
  document.querySelectorAll('.pu,.fade,.plate').forEach(function(e){io.observe(e);});

  var cio=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){
        var cs=[].slice.call(e.target.querySelectorAll('.card'));
        cs.forEach(function(c,i){ c.style.transitionDelay=(i*0.15)+'s'; c.classList.add('on'); });
        cio.unobserve(e.target);
      }
    });
  },{rootMargin:'-80px',threshold:.1});
  document.querySelectorAll('.cards').forEach(function(e){cio.observe(e);});

  document.querySelectorAll('[data-reveal]').forEach(function(p){
    var t=p.dataset.reveal, f=document.createDocumentFragment();
    for(var i=0;i<t.length;i++){
      var b=document.createElement('b'); b.textContent=t[i]; f.appendChild(b);
    }
    p.textContent=''; p.appendChild(f);
    var ch=p.querySelectorAll('b');
    function upd(){
      var r=p.getBoundingClientRect(), vh=innerHeight;
      var prog=(vh*0.8-r.top)/(r.height+vh*0.6);
      prog=Math.max(0,Math.min(1,prog));
      ch.forEach(function(c,i){
        var cp=i/ch.length;
        c.style.opacity = prog>=cp+0.05 ? 1 : (prog<=cp-0.1 ? .2 : (.2+.8*((prog-(cp-0.1))/0.15)));
      });
    }
    if(rm){ ch.forEach(function(c){c.style.opacity=1;}); }
    else { addEventListener('scroll',upd,{passive:true}); upd(); }
  });

  /* 動画は視界の300px手前から読み込む */
  var vio=new IntersectionObserver(function(es){
    es.forEach(function(e){
      var v=e.target;
      if(e.isIntersecting){ if(!v.src&&v.dataset.src){v.src=v.dataset.src;v.load();} if(!rm)v.play().catch(function(){}); }
      else if(v.src){ v.pause(); }
    });
  },{rootMargin:'300px 0px',threshold:.2});
  document.querySelectorAll('video[data-src]').forEach(function(v){vio.observe(v);});
})();